<template>
  <Sidebar variant="sidebar" collapsible="none" class="tw-border-r tw-border-border">
    <SidebarHeader class="tw-flex tw-justify-start tw-py-4 tw-mb-2 tw-px-4">
      <img src="/assets/vitable-logo.png" alt="logo" width="150px" />
    </SidebarHeader>

    <SidebarContent class="tw-px-4">
      <DashboardNavItems />
    </SidebarContent>

    <SidebarFooter class="tw-px-4">
      <DashboardUserProfile />
    </SidebarFooter>
  </Sidebar>
</template>

<script setup lang="ts">
import DashboardNavItems from "./DashboardNavItems.vue"
import DashboardUserProfile from "./DashboardUserProfile.vue"
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from "@/components/ui/sidebar"
</script>
